import { render, staticRenderFns } from "./imageEditor.vue?vue&type=template&id=19a9f4f0&scoped=true&"
import script from "./imageEditor.vue?vue&type=script&lang=js&"
export * from "./imageEditor.vue?vue&type=script&lang=js&"
import style0 from "./imageEditor.vue?vue&type=style&index=0&id=19a9f4f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a9f4f0",
  null
  
)

export default component.exports